import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// @material-ui/icons
// core components
import cardHeaderStyle from 'assets/jss/core/cardHeaderStyle';

function CardHeader({ ...props }) {
  const {
    classes,
    className,
    children,
    color,
    plain,
    stats,
    icon,
    title,
    subtitle,
    ...rest
  } = props;
  const cardHeaderClasses = classNames({
    [classes.cardHeader]: true,
    [classes[`${color}CardHeader`]]: color,
    [classes.cardHeaderPlain]: plain,
    [classes.cardHeaderStats]: stats,
    [classes.cardHeaderIcon]: icon,
    [className]: className !== undefined,
  });
  return (
    <div className={cardHeaderClasses} {...rest}>
      {children}
      <div className={classes.titleContainer}>
        {title ? <span className={classes.title}>{title}</span> : null}
        {subtitle ? <span className={classes.subtitle}>{subtitle}</span> : null}
      </div>
    </div>
  );
}

CardHeader.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(['warning', 'success', 'danger', 'info', 'primary', 'rose']),
  icon: PropTypes.bool,
  plain: PropTypes.bool,
  stats: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default withStyles(cardHeaderStyle)(CardHeader);
